export default {
  buttons: {
    next: "Próximo",
    prev: "Voltar",
    skip: "Pular",
    done: "Concluído",
    gotIt: "Entendi",
  },
  messages: {
    dontShowAgainLabel: "Não mostrar novamente",
    stepNumbersOfLabel: "de",
  },
};
